import {M as d} from '@theme/global';
import '@theme/request-idle-callback';
class s extends d {
  constructor() {
    super();
  }
  hide() {
    super.hide();
  }
  show(e) {
    super.show(e), this.showActiveMedia();
  }
  showActiveMedia() {
    this.querySelectorAll(
      `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
    ).forEach((a) => {
      a.classList.remove('active');
    });
    const e = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`),
      t = e.querySelector('template'),
      i = t ? t.content : null;
    e.classList.add('active'), e.scrollIntoView();
    const o = this.querySelector('[role="document"]');
    (o.scrollLeft = (e.width - o.clientWidth) / 2),
      e.nodeName == 'DEFERRED-MEDIA' && i && i.querySelector('.js-youtube') && e.loadContent();
  }
}
customElements.get('product-modal') || customElements.define('product-modal', s);
